import { observer } from "mobx-react-lite";
import { HomeView } from "../views/homeView";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const Home = observer(function SidebarRender(props) {
  const navigate = useNavigate();

  useEffect(() => {
    const hasVisitedBefore = localStorage.getItem("firstTime");
    if (!hasVisitedBefore) {
      localStorage.setItem("firstTime", "true");
    } else {
      localStorage.setItem("firstTime", "false");
    }
  }, []);

  return (
    <HomeView
      planetsList={props.model.planetsList}
      toGameplay={toGameplay}
      suspense={props.model.suspense}
      currentPlanet={props.model.currentPlanet}
    ></HomeView>
  );

  async function toGameplay(evt) {
    //evt.preventDefault;
    props.model.resetGame();
    await props.model.doSearch();
    await props.model.extractPlanet();
    await props.model.initializeGame();
    navigate("/gameplay");
  }
});

export { Home };
